import React from "react";
import googleicon from "../../Images/Google-icon.png";
import appleicon from "../../Images/Apple-icon.png";
import mockup from "../../Images/mockup.png";
import Grid from "@mui/material/Grid";
import { useThemeColors } from "../../Context/Theme";
import { BLACK } from "../../styles/color";

const AppSuggestion = ({isAtAllEvents}) => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  return (
    <div
    className="fo_css_event_app_suggestion_content"
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isAtAllEvents? "#FAFAFA" : backgroundColor || "#FAFAFA",
        
      }}
    >
      <Grid
        container
        spacing={4}
        justifyContent="center"
        className="p-5"
        style={{
          backgroundColor: isAtAllEvents? "#FAFAFA" : backgroundColor || "#FFF8F8",
          margin: 0,
          width: "90%",
          borderRadius: "1.2rem",
          overflow: "hidden",
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src={mockup}
            alt=""
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className="mt-5 d-flex flex-column justify-content-center"
        >
          <div>
            <p
              className="fw-bold mb-1"
              style={{ fontSize: fontSizeHeading || "30px", fontWeight: fontWeightHeading || "700", fontFamily: fontFamilyHeading, color: textColor || BLACK }}
            >
              Download our application
            </p>
          </div>
          <div className="mb-2">
            <p
              style={{ fontSize: fontSize ||"18px", fontWeight: fontWeight || "400", fontFamily, color: "#6F6F6F" }}
            >
             Tracking your orders at every event becomes a breeze when you download our app.
            </p>
          </div>
          <div>
            <img
              src={googleicon}
              className="mr-3"
              alt="Google Play Store"
              style={{ marginRight: "15px" }}
            />
            <img src={appleicon} alt="Apple App Store" />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default AppSuggestion;
